/* eslint-disable default-case */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import Select from "react-select";
import { useCookies } from "react-cookie";
import { v4 as uuidv4 } from "uuid";
import Link from "next/link";
import { useRouter } from "next/router";
import { AppContext } from "../../../context/state";
import Checkbox from "../../../components/form/Checkbox";
import { TableHeader } from "../../../components/table/TableHeader";
import { authPostRequest } from "../../../utils/authGetRequest";
import MainLayout from "../../../components/MainLayout/MainLayout";
import SliderRangeDual from "../../../components/slider-range/SliderRangeDual";
import transformTime from "../linevalue-welcome/utils/transformTime";
import Utils from "../../../utils/Utils";
import logoNBA from "../../../assets/images/League_NBA.png";
import logoNCAA from "../../../assets/images/League_NCAA.png";
import WNBALogo from "../../../assets/images/WNBALogo.png";
import Image from "next/image";
import WinningMetrics from "../../../components/WinningMetrics";
import { SQHeaderLockContent } from "../../../components/SQPremiumLock/SQPremiumLock";
import Top3Trends from "../../../components/Top3Trends";
import { getDefYear } from "../../../constants/main";
import Head from "next/head";
const TrendFinder = () => {
  const router = useRouter();

  const [user, setUser] = useState(null);
  const [cookies, setCookie] = useCookies(["token_access, name"]);
  const [authToken, setAuthToken] = useState(null);
  const [domLoaded, setDomLoaded] = useState(false);
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
    setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
    setDomLoaded(true);
    document.title = "Trend Finder | ShotQuality Bets";
  }, []);
  const appcontext = useContext(AppContext);
  const { store, setStore } = appcontext;
  let leagueFromUrl = router.query?.league;
  let leagueName = router.query?.league;
  if (leagueFromUrl === "ncaa") {
    leagueFromUrl = "college_mens";
  } else if (leagueFromUrl === "ncaaw") {
    leagueFromUrl = "college_womens";
  }
  const [teams, setTeams] = useState(null);
  let defaultTeam = "Atlanta Hawks";
  if (leagueFromUrl === "college_mens") {
    defaultTeam = "Louisville";
  } else if (leagueFromUrl === "wnba") {
    defaultTeam = "Atlanta Dream";
  }
  const leagueNameCaps = leagueName.toUpperCase();
  const [team, setTeam] = useState(defaultTeam);
  const [conference, setConference] = useState(null);
  const [conferences, setConferences] = useState([]);
  const [locations, setLocations] = useState([]);
  const [gameType, setGameType] = useState([]);
  const [pastGames, setPastGames] = useState([]);
  const [selectedGames, setSelectedGames] = useState("Past Games");
  const [pastGamesFiltered, setPastGamesFiltered] = useState([]);
  const [futureGamesFiltered, setFutureGamesFiltered] = useState([]);

  // const [year, setYear] = useState(getDefYear(leagueFromUrl));
  const [year, setYear] = useState("2024");
  // const [defaultLineRange, setDefaultLineRange] = useState([-10, 10]);
  const [defaultLineRange, setDefaultLineRange] = useState([-20, 20]); //for nba
  const [lineRange, setLineRange] = useState(defaultLineRange);
  // const [defaultTotalRange, setDefaultTotalRange] = useState([0, 10]);
  const [defaultTotalRange, setDefaultTotalRange] = useState(leagueFromUrl === "wnba" ? [150, 180] : [195, 270]); //for nba
  const [totalRange, setTotalRange] = useState(defaultTotalRange);

  const isStandardPlan = Utils.hasStandardPlan(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user) || Utils.isTrader(user);

  const filterLine = (e) => {
    setLineRange(e);
  };

  const filterTotal = (e) => {
    setTotalRange(e);
  };
  useEffect(() => {
    const result = pastGames.filter(
      (game) =>
        game.closing_spread >= lineRange[0] &&
        game.closing_spread <= lineRange[1] &&
        game.closing_total >= totalRange[0] &&
        game.closing_total <= totalRange[1]
    );
    setPastGamesFiltered(result);
  }, [lineRange, totalRange, pastGames]);
  useEffect(() => {
    setLineRange(defaultLineRange);
    setTotalRange(defaultTotalRange);
  }, [defaultLineRange, defaultTotalRange]);

  useEffect(() => {
    if (leagueFromUrl) {
      setStore({ ...store, leagueType: leagueFromUrl });
      if (leagueFromUrl === "college_mens") {
        setTeam("Louisville");
      } else if (leagueFromUrl === "nba") {
        setTeam("Atlanta Hawks");
      } else if (leagueFromUrl === "wnba") {
        setTeam("Atlanta Dream");
      }
    }
  }, [leagueFromUrl]);

  useEffect(() => {
    if (pastGames && pastGames.length > 0) {
      if (pastGames[0].team === team) {
        calculateDefaultRange(pastGames, true);
      }
    }
  }, [team]);

  useEffect(() => {
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${leagueFromUrl}/${year}/team-standings`)
      .then((response) => response.json())
      .then((response) => {
        let teams = [{ value: null, sort: "AA", label: "Select team..." }];
        response.data.forEach((val) => {
          teams.push({
            value: val.Team_Name,
            sort: val.Team_Name,
            label: val.Team_Name,
          });
        });

        let confs = [{ value: null, sort: "AA", label: "Select conference..." }];
        response.conferences.forEach((el) => confs.push({ value: el, sort: el, label: el }));

        setTeams([...teams].sort((a, b) => (a.sort > b.sort ? 1 : -1)));
        setConferences([...confs].sort((a, b) => (a.sort > b.sort ? 1 : -1)));
      })
      .catch(async (err) => {
        console.error(err);
      });
  }, [leagueFromUrl]);

  const calculateDefaultRange = (data, setRanges = false) => {
    const min = data.reduce((min, curr) => (min.closing_total < curr.closing_total ? min : curr), 0).closing_total;
    const max = data.reduce((max, curr) => (max.closing_total > curr.closing_total ? max : curr), 0).closing_total;
    // setDefaultTotalRange([Math.floor(min), Math.ceil(max)]);//commenting for nba
    if (leagueFromUrl === "ncaa" || leagueFromUrl === "college_mens") {
      setDefaultTotalRange([Math.floor(min || 0), Math.ceil(max || 0)]);
    }
    const minClosingSpread = data.reduce(
      (min, curr) => (min.closing_spread < curr.closing_spread ? min : curr),
      0
    ).closing_spread;
    const maxClosingSpread = data.reduce(
      (max, curr) => (max.closing_spread > curr.closing_spread ? max : curr),
      0
    ).closing_spread;
    // setDefaultLineRange([Math.floor(minClosingSpread), Math.ceil(maxClosingSpread)]);//commenting for nba
    if (leagueFromUrl === "ncaa" || leagueFromUrl === "college_mens") {
      setDefaultLineRange([Math.floor(minClosingSpread || 0), Math.ceil(maxClosingSpread || 0)]);
    }
    let result = data.filter(
      (game) =>
        game.closing_spread >= Math.floor(minClosingSpread) &&
        game.closing_spread <= Math.ceil(maxClosingSpread) &&
        game.closing_total >= Math.floor(min) &&
        game.closing_total <= Math.ceil(max)
    );
    setPastGamesFiltered(result);
  };

  useEffect(() => {
    if (domLoaded && user && team) {
      authPostRequest(`/api/${leagueFromUrl}/trend-finder/future-games`, authToken, {
        team,
        conference,
        locations,
        gameType,
      })
        .then((response) => response.data)
        .then((response) => {
          setFutureGamesFiltered(
            response.data.sort((a, b) => {
              if (a.date > b.date) {
                return 1;
              }
              if (a.date < b.date) {
                return -1;
              }
              return 0;
            })
          );
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  if (response.access_token) {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  }
                });
            } catch (error) {
              console.error(error);
            }

            // router.push("/login#login");
          }
          console.error(err);
        });

      authPostRequest(`/api/${leagueFromUrl}/trend-finder/past-games`, authToken, {
        team,
        conference,
        locations,
        gameType,
      })
        .then((response) => response.data)
        .then((response) => {
          setPastGames(response.data);
          if (
            totalRange[0] === defaultTotalRange[0] &&
            totalRange[1] === defaultTotalRange[1] &&
            lineRange[0] === defaultLineRange[0] &&
            lineRange[1] === defaultLineRange[1]
          ) {
            calculateDefaultRange(response.data);

            // setPastGamesFiltered(result);
          } else {
            let result = response.data.filter(
              (game) =>
                game.closing_spread >= lineRange[0] &&
                game.closing_spread <= lineRange[1] &&
                game.closing_total >= totalRange[0] &&
                game.closing_total <= totalRange[1]
            );

            setPastGamesFiltered(result);
            // setPastGamesFiltered(response.data);
          }
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  if (response.access_token) {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  }
                });
            } catch (error) {
              console.error(error);
            }
          }
          console.error(err);
        });
    }

    const opts = {
      team,
      conference,
      locations,
      gameType,
    };

    if (domLoaded && ((!user && team) || !user?.has_paid)) {
      fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/trend-finder/future-games/unprotected`, {
        method: "post",
        body: JSON.stringify(opts),
      })
        .then((response) => response.json())
        .then((response) => {
          setFutureGamesFiltered(response.data);
        })
        .catch(async (err) => {
          console.error(err);
        });

      fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/trend-finder/past-games/unprotected`, {
        method: "post",
        body: JSON.stringify(opts),
      })
        .then((response) => response.json())
        .then((response) => {
          setPastGames(response.data);
          // calculateDefaultRange(response.data);
          if (
            totalRange[0] === defaultTotalRange[0] &&
            totalRange[1] === defaultTotalRange[1] &&
            lineRange[0] === defaultLineRange[0] &&
            lineRange[1] === defaultLineRange[1]
          ) {
            calculateDefaultRange(response.data);

            // setPastGamesFiltered(result);
          } else {
            let result = response.data.filter(
              (game) =>
                game.closing_spread >= lineRange[0] &&
                game.closing_spread <= lineRange[1] &&
                game.closing_total >= totalRange[0] &&
                game.closing_total <= totalRange[1]
            );

            setPastGamesFiltered(result);
            // setPastGamesFiltered(response.data);
          }
        })
        .catch(async (err) => {
          console.error(err);
        });
    }

    if (domLoaded && user && conference) {
      authPostRequest(`/api/${leagueFromUrl}/trend-finder/past-games`, authToken, {
        team,
        conference,
        locations,
        gameType,
      })
        .then((response) => response.data)
        .then((response) => {
          setPastGamesFiltered(response.data);
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  if (response.access_token) {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  }
                });
            } catch (error) {
              console.error(error);
            }
          }
          console.error(err);
        });

      authPostRequest(`/api/${leagueFromUrl}/trend-finder/future-games`, authToken, {
        team,
        conference,
        locations,
        gameType,
      })
        .then((response) => response.data)
        .then((response) => {
          setFutureGamesFiltered(response.data);
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  if (response.access_token) {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  }
                });
            } catch (error) {
              console.error(error);
            }
          }
          console.error(err);
        });

      // authPostRequest(`/api/${leagueName}/trend-finder/past-games`, authToken, {
      //   team,
      //   conference,
      //   locations,
      //   gameType,
      // })
      //   .then((response) => response.data)
      //   .then((response) => {
      //     setPastGames(response.data);
      //     if (totalRange[0] === 110 && totalRange[1] === 170 && lineRange[0] === -20 && lineRange[1] === 20) {
      //       setPastGamesFiltered(response.data);
      //     } else {
      //       const result = response.data.filter(
      //         (game) =>
      //           game.closing_spread >= lineRange[0] &&
      //           game.closing_spread <= lineRange[1] &&
      //           game.closing_total >= totalRange[0] &&
      //           game.closing_total <= totalRange[1]
      //       );
      //       setPastGamesFiltered(result);
      //     }
      //   })
      //   .catch(async (err) => {
      //     if (err.message.includes("401")) {
      //       try {
      //         const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
      //           method: "POST",
      //           headers: {
      //             Authorization: `Bearer ${authToken}`,
      //           },
      //           body: authToken,
      //         })
      //           .then((res) => res.json())
      //           .then((response) => {
      //             if (response.access_token) {
      //               setCookie("token_access", response.access_token);
      //               setAuthToken(response.access_token);
      //             }
      //           });
      //       } catch (error) {
      //         console.error(error);
      //       }
      //     }
      //     console.error(err);
      //   });
    }
  }, [store, domLoaded, team, conference, locations, gameType, authToken, leagueFromUrl]);

  const handleDownloadCSV = (e) => {
    e.preventDefault();
    const modifiedResult = [];
    pastGamesFiltered.forEach((el) => {
      modifiedResult.push({
        Team: el.team,
        Opponent: el.opponent,
        closing_spread: el.closing_spread,
        closing_total: el.closing_total,
        date: el.date,
        location: el.location,
        score: el.score,
        spread_result: el.spread_result,
        sq_ml_loss: el.sq_ml_loss,
        sq_ml_win: el.sq_ml_win,
        sq_score: el.sq_score,
        sq_spread_result: el.sq_spread_result,
        sq_total_result: el.sq_total_result,
        total_result: el.total_result,
      });
    });
    Utils.jsonToCsv(modifiedResult);
  };

  return (
    <MainLayout>
      <Head>
        <title>{`${leagueNameCaps} Trend Finder | ShotQuality`}</title>

        <meta
          name="description"
          content={`Explore every ${leagueNameCaps} basketball team to easily find odds, predictions, spreads, picks and parlays, and more. ShotQuality
          Bets provides the most accurate, robust and predictable dataset for ${leagueNameCaps} basketball odds, picks and parlays. Access our dataset now to
          unlock all NCAAB odds and easily identify points-of-value for each game.`}
        />
      </Head>
      {domLoaded && (
        <main id="ContentBox" style={{ minHeight: "100vh" }}>
          <div className="MiscStats Trend-finder-page">
            <section className="header-secondary">
              <div className="container-fluid d-flex align-items-center">
                <Image
                  height={80}
                  width={80}
                  src={leagueFromUrl === "nba" ? logoNBA.src : leagueFromUrl === "wnba" ? WNBALogo.src : logoNCAA.src}
                  alt="Selected League"
                  style={{ marginRight: "24px" }}
                />

                <h2 className="mb-0">
                  {leagueFromUrl === "nba" ? "NBA Men's" : leagueFromUrl === "wnba" ? "WNBA Women's" : "NCAA Men's"}{" "}
                  Basketball Trend Finder
                </h2>
              </div>
            </section>

            <section className="page-content">
              <div className="container-fluid">
                {pastGames && pastGames.length > 0 && <Top3Trends data={pastGames} team={team} />}
                <div className="row select-teams-container">
                  {/* <div className="select-container d-flex col-md-4"></div> */}
                  <div className="col-md-4 col-sm-12 mb-4">
                    <label className="fw-7">Team</label>
                    <Select
                      id={1}
                      instanceId="one"
                      options={teams}
                      isDisabled={conference !== null}
                      key={team}
                      defaultValue={{
                        label: team,
                        value: team,
                      }}
                      onChange={(e) => {
                        setConference(null);
                        setLineRange(defaultLineRange);
                        setTotalRange(defaultTotalRange);
                        setLocations([]);
                        setGameType([]);
                        setTeam(e.value);
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-sm-12 mb-4">
                    <label className="fw-7">Conference</label>
                    <Select
                      instanceId="two"
                      id={2}
                      isDisabled={team !== null}
                      options={team !== null ? [] : conferences}
                      onChange={(e) => {
                        setTeam(null);
                        setConference(e.value);
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-sm-12 mb-4">
                    <label className="fw-7">Location</label>
                    <div
                      className="d-flex justify-content-evenly"
                      style={{
                        justifySelf: "flex-start",
                      }}
                    >
                      <Checkbox
                        checked={locations?.includes("Home")}
                        onChange={() => {
                          if (locations?.includes("Home")) {
                            setLocations(locations.filter((el) => el !== "Home"));
                          } else {
                            setLocations([...locations, "Home"]);
                          }
                        }}
                        label={
                          <span
                            className="form-group"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              marginRight: "20px",

                              justifySelf: "flex-start",
                            }}
                          >
                            Home
                          </span>
                        }
                      />
                      <Checkbox
                        checked={locations?.includes("Neutral")}
                        onChange={() => {
                          if (locations?.includes("Neutral")) {
                            setLocations(locations.filter((el) => el !== "Neutral"));
                          } else {
                            setLocations([...locations, "Neutral"]);
                          }
                        }}
                        label={
                          <span
                            className="form-group"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              marginRight: "20px",
                            }}
                          >
                            Neutral
                          </span>
                        }
                      />
                      <Checkbox
                        checked={locations?.includes("Away")}
                        onChange={() => {
                          if (locations?.includes("Away")) {
                            setLocations(locations.filter((el) => el !== "Away"));
                          } else {
                            setLocations([...locations, "Away"]);
                          }
                        }}
                        label={
                          <span className="form-group" style={{ fontWeight: "bold", fontSize: "16px" }}>
                            Away
                          </span>
                        }
                      />
                    </div>
                  </div>
                  {leagueFromUrl !== "wnba" ? (
                    <div className="col-md-4 col-sm-12 mb-4">
                      <label className="fw-7">Game Type</label>
                      <div className="d-flex justify-content-evenly">
                        <Checkbox
                          checked={gameType?.includes("Conference")}
                          onChange={() => {
                            if (gameType?.includes("Conference")) {
                              setGameType(gameType.filter((el) => el !== "Conference"));
                            } else {
                              setGameType([...gameType, "Conference"]);
                            }
                          }}
                          label={
                            <span className="form-group" style={{ fontWeight: "bold", fontSize: "16px" }}>
                              Conference
                            </span>
                          }
                        />
                        <Checkbox
                          checked={gameType?.includes("Non-Conference")}
                          onChange={() => {
                            if (gameType?.includes("Non-Conference")) {
                              setGameType(gameType.filter((el) => el !== "Non-Conference"));
                            } else {
                              setGameType([...gameType, "Non-Conference"]);
                            }
                          }}
                          label={
                            <span className="form-group" style={{ fontWeight: "bold", fontSize: "16px" }}>
                              Non-Conference
                            </span>
                          }
                        />
                        <Checkbox
                          checked={gameType?.includes("Both")}
                          onChange={() => {
                            if (gameType?.includes("Both")) {
                              setGameType(gameType.filter((el) => el !== "Both"));
                            } else {
                              setGameType([...gameType, "Both"]);
                            }
                          }}
                          label={
                            <span className="form-group" style={{ fontWeight: "bold", fontSize: "16px" }}>
                              Both
                            </span>
                          }
                        />
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="row" style={{ marginTop: 20 }}>
                  <div className="col-md-4 col-sm-12 px-sm-6">
                    <label className="fw-7">Line</label>
                    <SliderRangeDual
                      // title="PK"
                      min={defaultLineRange[0]}
                      max={defaultLineRange[1]}
                      filter={filterLine}
                    />
                  </div>
                  <div className="col-md-4 col-sm-12 px-sm-6">
                    <label className="fw-7">Total</label>
                    <SliderRangeDual
                      // title="140"
                      min={defaultTotalRange[0]}
                      max={defaultTotalRange[1]}
                      filter={filterTotal}
                    />
                  </div>
                </div>

                {domLoaded && (team || conference) ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="row d-flex mt-5 justify-content-between align-items-center"
                        style={{
                          backgroundColor: "#fff",
                          boxShadow: "2px 4px 30px rgba(107, 108, 114, 0.12)",
                          borderRadius: "12px",
                          padding: "30px",
                        }}
                      >
                        <div
                          className="col-md-3 col-sm-6 d-flex justify-content-around"
                          style={{ borderRight: " 1px solid #D0D2D9" }}
                        >
                          <div>
                            <p>ML Record</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                fontFamily: "var(--font-oswald)",
                                fontSize: "28px",
                              }}
                            >
                              {pastGamesFiltered.filter((obj) => obj.ml_win === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.ml_loss === true).length}
                            </h3>
                          </div>
                          <div>
                            <p>SQ ML Record</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                fontFamily: "var(--font-oswald)",
                                fontSize: "28px",
                              }}
                            >
                              {isStandardPlan || isPremiumPlan ? (
                                pastGamesFiltered.reduce(
                                  (total, currentValue) => (total = total + Math.round(currentValue.sq_ml_win)),
                                  0
                                ) +
                                "-" +
                                pastGamesFiltered.reduce(
                                  (total, currentValue) => (total = total + Math.round(currentValue.sq_ml_loss)),
                                  0
                                )
                              ) : (
                                <div
                                  className="trendFinderDummyLock"
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <TableHeader headers={SQHeaderLockContent} />
                                  <span
                                    style={{
                                      userSelect: "none",
                                      filter: "blur(5px)",
                                    }}
                                  >
                                    4 - 20
                                  </span>
                                </div>
                              )}
                            </h3>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-6 d-flex justify-content-around">
                          <div>
                            <p>ATS Record</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                fontFamily: "var(--font-oswald)",
                                fontSize: "28px",
                              }}
                            >
                              {pastGamesFiltered.filter((obj) => obj.cover_w === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.cover_l === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.cover_push === true).length}
                            </h3>
                          </div>
                          <div>
                            <p>SQ ATS Record</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                fontFamily: "var(--font-oswald)",
                                fontSize: "28px",
                              }}
                            >
                              {isStandardPlan || isPremiumPlan ? (
                                pastGamesFiltered.filter((obj) => obj.sq_cover_w === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.sq_cover_l === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.sq_cover_push === true).length
                              ) : (
                                <div
                                  className="trendFinderDummyLock"
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <TableHeader headers={SQHeaderLockContent} />
                                  <span
                                    style={{
                                      userSelect: "none",
                                      filter: "blur(5px)",
                                    }}
                                  >
                                    14-18-5
                                  </span>
                                </div>
                              )}
                            </h3>
                          </div>
                        </div>

                        <div
                          className="col-md-3 col-sm-6 d-flex justify-content-around"
                          style={{ borderRight: " 1px solid #D0D2D9" }}
                        >
                          <div>
                            <p>OU Record</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                fontFamily: "var(--font-oswald)",
                                fontSize: "28px",
                              }}
                            >
                              {pastGamesFiltered.filter((obj) => obj.over === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.under === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.ou_push === true).length}
                            </h3>
                          </div>
                          <div>
                            <p>SQ OU Record</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                fontFamily: "var(--font-oswald)",
                                fontSize: "28px",
                              }}
                            >
                              {isStandardPlan || isPremiumPlan ? (
                                pastGamesFiltered.filter((obj) => obj.sq_over === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.sq_under === true).length +
                                "-" +
                                pastGamesFiltered.filter((obj) => obj.sq_ou_push === true).length
                              ) : (
                                <div
                                  className="trendFinderDummyLock"
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <TableHeader headers={SQHeaderLockContent} />
                                  <span
                                    style={{
                                      userSelect: "none",
                                      filter: "blur(5px)",
                                    }}
                                  >
                                    15-4-5
                                  </span>
                                </div>
                              )}
                            </h3>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-6 d-flex justify-content-around">
                          <div>
                            <p>ATS Value</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                color:
                                  pastGamesFiltered.filter((obj) => obj.sq_cover_w === true).length -
                                    pastGamesFiltered.filter((obj) => obj.cover_w === true).length >
                                  0
                                    ? "green"
                                    : pastGamesFiltered.filter((obj) => obj.sq_cover_w === true).length -
                                        pastGamesFiltered.filter((obj) => obj.cover_w === true).length ===
                                      0
                                    ? "black"
                                    : "red",
                                fontFamily: "var(--font-oswald)",
                                fontSize: "24px",
                              }}
                            >
                              {isStandardPlan || isPremiumPlan ? (
                                "(" +
                                (Math.sign(
                                  pastGamesFiltered.filter((obj) => obj.sq_cover_w === true).length -
                                    pastGamesFiltered.filter((obj) => obj.cover_w === true).length
                                ) === "1"
                                  ? "+"
                                  : "") +
                                (pastGamesFiltered.filter((obj) => obj.sq_cover_w === true).length -
                                  pastGamesFiltered.filter((obj) => obj.cover_w === true).length) +
                                " ATS val)"
                              ) : (
                                <div
                                  className="trendFinderDummyLock"
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <TableHeader headers={SQHeaderLockContent} />
                                  <span
                                    style={{
                                      userSelect: "none",
                                      filter: "blur(5px)",
                                    }}
                                  >
                                    (=4 ATS VAL)
                                  </span>
                                </div>
                              )}
                            </h3>
                          </div>
                          <div>
                            <p>O/U Value</p>
                            <h3
                              style={{
                                fontWeight: 700,
                                color:
                                  pastGamesFiltered.filter((obj) => obj.sq_over === true).length -
                                    pastGamesFiltered.filter((obj) => obj.over === true).length >
                                  0
                                    ? "green"
                                    : pastGamesFiltered.filter((obj) => obj.sq_over === true).length -
                                        pastGamesFiltered.filter((obj) => obj.over === true).length ===
                                      0
                                    ? "black"
                                    : "red",
                                fontFamily: "var(--font-oswald)",
                                fontSize: "24px",
                              }}
                            >
                              {isStandardPlan || isPremiumPlan ? (
                                "(" +
                                (Math.sign(
                                  pastGamesFiltered.filter((obj) => obj.sq_over === true).length -
                                    pastGamesFiltered.filter((obj) => obj.over === true).length
                                ) === "1"
                                  ? "+"
                                  : "") +
                                (pastGamesFiltered.filter((obj) => obj.sq_over === true).length -
                                  pastGamesFiltered.filter((obj) => obj.over === true).length) +
                                " Over val)"
                              ) : (
                                <div
                                  className="trendFinderDummyLock"
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <TableHeader headers={SQHeaderLockContent} />
                                  <span
                                    style={{
                                      userSelect: "none",
                                      filter: "blur(5px)",
                                    }}
                                  >
                                    (+1 Over val)
                                  </span>
                                </div>
                              )}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                ) : null}

                {(team || conference) && (pastGamesFiltered?.length || futureGamesFiltered?.length) ? (
                  <>
                    <div className="row">
                      <div className="col-md-12 Sandbox">
                        <div className="d-flex categories">
                          <button
                            className={selectedGames === "Past Games" ? "active fw-8" : "fw-8"}
                            onClick={() => setSelectedGames("Past Games")}
                            style={{ marginRight: "24px" }}
                          >
                            Past Games ({pastGamesFiltered?.length})
                          </button>
                          <button
                            className={selectedGames === "Upcoming Games" ? "active fw-8" : "fw-8"}
                            onClick={() => setSelectedGames("Upcoming Games")}
                          >
                            Upcoming Games ({futureGamesFiltered?.length})
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {selectedGames === "Past Games" ? (
                        <>
                          {isPremiumPlan && (
                            <div className="col-sm-12">
                              <button className="btn export-button float-right mb-2" onClick={handleDownloadCSV}>
                                Export to CSV
                              </button>
                            </div>
                          )}
                          <div style={{ clear: "both" }}></div>
                          {pastGamesFiltered.map((el) => {
                            return (
                              <div className="col-sm-12" key={uuidv4()}>
                                <a
                                  className="row pastGame"
                                  href={`/game/${leagueName}/${year}/${el.team}/${el.game_link}`}
                                  target="_blank"
                                >
                                  <div
                                    className="col-md-2 col-sm-12 text-center pt-3"
                                    style={{ borderRight: "1px solid #D0D2D9" }}
                                  >
                                    <Link
                                      className="tag "
                                      href={`/game/${leagueName}/${year}/${el.team}/${el.game_link}`}
                                      target={"_blank"}
                                    >
                                      {dayjs(el.date).format("ddd, D MMM")}
                                    </Link>

                                    <div className="d-flex justify-content-center mt-3">
                                      <Link
                                        href={`/team/${leagueName}/${year}/${el.team}`}
                                        style={{ color: "#212529" }}
                                        target={"_blank"}
                                      >
                                        <Image
                                          alt="team"
                                          height={25}
                                          width={25}
                                          src={`http://shotqualitybets.com/static/media/logos/${el.team}.png`}
                                          style={{
                                            maxHeight: "24px",
                                            maxWidth: "24px",
                                            marginRight: "12px",
                                          }}
                                        />
                                        <span
                                          style={{
                                            fontFamily: "var(--font-inter)",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            color: "#0F131B",
                                          }}
                                        >
                                          {el.team}
                                        </span>
                                      </Link>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                      <Link
                                        href={`/team/${leagueName}/${year}/${el.opponent}`}
                                        style={{ color: "#212529" }}
                                        target={"_blank"}
                                      >
                                        <Image
                                          alt="opponent"
                                          height={25}
                                          width={25}
                                          src={`http://shotqualitybets.com/static/media/logos/${el.opponent}.png`}
                                          style={{
                                            maxHeight: "24px",
                                            maxWidth: "24px",
                                            marginRight: "12px",
                                          }}
                                        />
                                        <span
                                          style={{
                                            fontFamily: "var(--font-inter)",
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            color: "#6B6C72",
                                          }}
                                        >
                                          {el.opponent}
                                        </span>
                                      </Link>
                                    </div>
                                  </div>
                                  <div className="col-md-2 pl-4 d-flex flex-column justify-content-between">
                                    <p>Score</p>
                                    <span
                                      style={{
                                        color:
                                          el.ml_win > 0.5 && el.sq_ml_win >= 0.5
                                            ? "green"
                                            : el.ml_win < 0.5 && el.sq_ml_win <= 0.5
                                            ? "red"
                                            : "orange",
                                      }}
                                    >
                                      {el.score}
                                    </span>
                                    <span
                                      style={{
                                        color:
                                          el.ml_win > 0.5 && el.sq_ml_win >= 0.5
                                            ? "green"
                                            : el.ml_win < 0.5 && el.sq_ml_win <= 0.5
                                            ? "red"
                                            : "orange",
                                      }}
                                    >
                                      {isPremiumPlan ? (
                                        `SQ ${el.sq_score.toString().split("-")[0].split(" ")[0]}${" "}
                                  ${Math.round(el.sq_score.toString().split("-")[0].split(" ")[1])}-
                                  ${Math.round(el.sq_score.toString().split("-")[1])}`
                                      ) : (
                                        <div
                                          className="trendFinderDummyLock"
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          <TableHeader headers={SQHeaderLockContent} />
                                          <span
                                            style={{
                                              userSelect: "none",
                                              filter: "blur(4px)",
                                            }}
                                          >
                                            SQ L, 88-88
                                          </span>
                                        </div>
                                      )}
                                    </span>
                                  </div>
                                  <div className="col-md-2 d-flex flex-column">
                                    <p style={{ marginBottom: 0 }}>Closing Spread</p>
                                    <span
                                      style={{
                                        margin: "auto 0",
                                      }}
                                    >
                                      {el.closing_spread > 0 ? "+" : ""}
                                      {el.closing_spread}
                                    </span>
                                  </div>
                                  <div className="col-md-2 d-flex flex-column">
                                    <p>Spread Result</p>
                                    <span>{el.spread_result}</span>
                                    <span>
                                      {isPremiumPlan ? (
                                        el.sq_spread_result?.includes("Push") ? (
                                          "SQ " + el.sq_spread_result
                                        ) : (
                                          `SQ ${el.sq_spread_result?.split(" ")[0]}${" "}
                                      ${el.sq_spread_result?.split(" ")[1]}${" "}
                                      ${Number(el.sq_spread_result?.split(" ")[2])?.toFixed(1)}`
                                        )
                                      ) : (
                                        <div
                                          className="trendFinderDummyLock"
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          <TableHeader headers={SQHeaderLockContent} />
                                          <span
                                            style={{
                                              userSelect: "none",
                                              filter: "blur(4px)",
                                            }}
                                          >
                                            SQ Win by 8.88
                                          </span>
                                        </div>
                                      )}
                                    </span>
                                  </div>
                                  <div className="col-md-2 d-flex flex-column ">
                                    <p style={{ marginBottom: 0 }}>Closing Total</p>
                                    <span style={{ margin: "auto 0" }}>{el.closing_total}</span>
                                  </div>
                                  <div className="col-md-2 d-flex flex-column">
                                    <p>Total Result</p>
                                    <span>{el.total_result}</span>
                                    <span>
                                      {isPremiumPlan ? (
                                        el.sq_total_result?.includes("Push") ? (
                                          "SQ " + el.sq_total_result
                                        ) : (
                                          `SQ ${el.sq_total_result?.split(" ")[0]}${" "}
                                  ${el.sq_total_result?.split(" ")[1]}${" "}
                                  ${Number(el.sq_total_result?.split(" ")[2])?.toFixed(1)}`
                                        )
                                      ) : (
                                        <div
                                          className="trendFinderDummyLock"
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          <TableHeader headers={SQHeaderLockContent} />
                                          <span
                                            style={{
                                              userSelect: "none",
                                              filter: "blur(4px)",
                                            }}
                                          >
                                            SQ Win by 8.88
                                          </span>
                                        </div>
                                      )}
                                    </span>
                                  </div>
                                </a>
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {futureGamesFiltered.map((el) => {
                            return (
                              <div className="col-sm-12 col-md-6" key={uuidv4()}>
                                <a
                                  target={"_blank"}
                                  className="row upcomingGameWrapper"
                                  href={`/matchup-output/${el.team}/${el.opponent}/${dayjs(el.date).format(
                                    "ddd, D MMM"
                                  )} ${el.time}`}
                                >
                                  <div className="col-sm-12 d-flex upcomingGame">
                                    <div
                                      className="col-md-7 d-flex flex-column justify-content-between"
                                      style={{ borderRight: "1px solid #D0D2D9" }}
                                    >
                                      <Link
                                        className="tag"
                                        href={`/matchup-output/${el.team}/${el.opponent}/${dayjs(el.date).format(
                                          "ddd, D MMM"
                                        )} ${el.time}`}
                                        target={"_blank"}
                                      >
                                        {dayjs(el.date).format("ddd, D MMM") + " " + transformTime(el.time)}
                                      </Link>

                                      <div className="d-flex">
                                        <Link
                                          href={`/team/${leagueName}/${year}/${el.team}`}
                                          style={{ color: "#212529" }}
                                          target={"_blank"}
                                        >
                                          <Image
                                            alt="team"
                                            height={25}
                                            width={25}
                                            src={`http://shotqualitybets.com/static/media/logos/${el.team}.png`}
                                            style={{
                                              maxHeight: "24px",
                                              maxWidth: "24px",
                                              marginRight: "12px",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontFamily: "var(--font-inter)",
                                              fontSize: "16px",
                                              fontWeight: 700,
                                              color: "#0F131B",
                                            }}
                                          >
                                            {el.team}
                                          </span>
                                        </Link>
                                      </div>
                                      <div className="d-flex">
                                        <Link
                                          href={`/team/${leagueName}/${year}/${el.opponent}`}
                                          style={{ color: "#212529" }}
                                          target={"_blank"}
                                        >
                                          <Image
                                            alt="opponent"
                                            height={25}
                                            width={25}
                                            src={`http://shotqualitybets.com/static/media/logos/${el.opponent}.png`}
                                            style={{
                                              maxHeight: "24px",
                                              maxWidth: "24px",
                                              marginRight: "12px",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontFamily: "var(--font-inter)",
                                              fontSize: "16px",
                                              fontWeight: 700,
                                              color: "#6B6C72",
                                            }}
                                          >
                                            {el.opponent}
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="col-md-5 pl-4 d-flex flex-column justify-content-center">
                                      <p>Score</p>
                                      <span>
                                        {el.projected_score}-{el.projected_opp_score}
                                      </span>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            );
                          })}
                        </>
                      )}
                    </div>
                  </>
                ) : null}
              </div>
            </section>
            <WinningMetrics targetPage={"Trends"} />
          </div>
        </main>
      )}
    </MainLayout>
  );
};

export default TrendFinder;
